<template>
	<div class="not-found">
		<div class="not-found__text">
			<div class="not-found__primary-text">
				{{ title }}
			</div>
			<div class="not-found__secondary-text">
				{{ subtitle }}
			</div>
		</div>
		<img
			class="not-found__graphic"
			:src="notFound"
			alt="Dead End graphic for page not found"
		/>
		<footer class="not-found__actions">
			<slot name="action">
				<ButtonClassic
					variant="primary"
					labelText="Go to Dashboard"
					@click="$router.push({ name: 'dashboard' })"
				/>
			</slot>
		</footer>
	</div>
</template>

<script>
import pageMixin from '@/mixins/page-mixin';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import NotFound from '@/assets/404.svg';

export default {
	Name: 'NotFound',
	components: {
		ButtonClassic
	},
	mixins: [pageMixin],
	data() {
		return {
			notFound: NotFound
		};
	},
	created() {
		this.hidePageLoader();
	},
	props: {
		title: {
			type: String,
			default: '404. Sorry page not found'
		},
		subtitle: {
			type: String,
			default:
				'You may have mistyped the address or the page may have moved.'
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * No results found
    * Can use SCSS variables = TRUE
*/

.not-found {
	@include transform-full-center;
	top: 40%;
	max-width: 420px;
	text-align: center;
	color: var(--bg-0-fg-4);
}

@include error-msg('not-found');

.not-found {
	flex-direction: column;
	margin-top: 0;
	gap: $gutter-xxl;

	&__text {
		align-items: center;
	}

	&__graphic {
		width: 190px;
	}

	&__secondary-text {
		width: 216px;
	}
}
</style>
